import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import {
  MyAppSettingController,
  useFindAllCategories,
  FindOffersEndingSoonController,
  SearchOffers,
  useMyIdentities,
} from "@njoy/controller";

import OfferCardSkeleton from "src/components/cards/OfferCardSkeleton";
import { OfferCountdownCard } from "../../components/cards/OfferCountdownCard";
import CategoryCardSkeleton from "../../components/cards/CategoryCardSkeleton";
import SearchInput from "../../components/uiMerge/searchInput";
import Loader from "../../components/loader/Loader";
import NoticeBox from "../../components/noticeBox/NoticeBox";
import PageLoader from "../shared/PageLoader";
import { TemplateSub } from "../../components/layouts/TemplateSub";
import { ConnectIdModal } from "../../components/modals/connectIdModal";

import blueNjoyLogo from "../../assets/discovery/blue-njoy.png";
import hotPotIcon from "../../assets/discovery/hot-pot.png";
import Banner0 from "../../assets/ad_banners/Banner0.png";
import Banner1 from "../../assets/ad_banners/Banner1.png";
import Banner2 from "../../assets/ad_banners/Banner2.png";
import Banner4 from "../../assets/ad_banners/Banner4.png";
import Banner5 from "../../assets/ad_banners/Banner5.png";
import Banner6 from "../../assets/ad_banners/Banner6.png";
import Banner7 from "../../assets/ad_banners/Banner7.png";
import Bolt from "../../assets/discovery/Bolt.svg";
import Medplus from "../../assets/discovery/Medplus.svg";
import Glo from "../../assets/discovery/Glo.svg";
import Adidas from "../../assets/discovery/addidas.svg";
import Buypower from "../../assets/discovery/buyPower.svg";
import searchIcon from "../../assets/discovery/search-icon.png";
import RightIcon from "../../assets/svg/rightArrowIcon.svg";

import { TopMerchant } from "../offers/constant/TopMerchants";
import * as ROUTES from "../../constants/routes";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Button from "../../components/uiMerge/newButton";
import { useCampaignFlow } from "../../components/campaign/CampaignFlowContext";
const Slider = require("react-slick").default;

const ads = [

  {
    id: 0,
    imgSrc: Banner0,
    url: "https://njoy.live/ambassadors/",
  },
  {
    id: 1,
    imgSrc: Banner1,
    url: "https://www.instagram.com/crackwings/?hl=en",
  },
  {
    id: 2,
    imgSrc: Banner2,
    url: "https://gigm.com/",
  },
  {
    id: 3,
    imgSrc: Banner4,
    url: "https://www.istore.com.ng/",
  },
  {
    id: 4,
    imgSrc: Banner5,
    url: "https://www.instagram.com/burg.co/?hl=en",
  },
  {
    id: 5,
    imgSrc: Banner6,
    url: "https://www.instagram.com/rararamen.ng/?hl=en",
  },
  {
    id: 6,
    imgSrc: Banner7,
    url: "https://rhbooks.com.ng/",
  },
];

const products = [
  {
    id: "adidas",
    imgSrc: Adidas,
    title: "Adidas",
  },
  {
    id: "bolt",
    imgSrc: Bolt,
    title: "Bolt",
  },
  {
    id: "medplus",
    imgSrc: Medplus,
    title: "Medplus Pharmacy",
  },
  {
    id: "buypower",
    imgSrc: Buypower,
    title: "BuyPower",
  },
  {
    id: "glo",
    imgSrc: Glo,
    title: "Glo",
  },
];

const sliderOptions = {
  dots: false,
  arrows: false,
  infinite: true,
  autoplay: true,
  speed: 800,
  autoplaySpeed: 3000,
  slidesToScroll: 1,
  variableWidth: true,
  centerMode: false,
};

const adBannerSliderOptions = {
  dots: false,
  arrows: false,
  infinite: true,
  autoplay: true,
  draggable: true,
  variableWidth: true,
  swipe: true,
  touchMove: true,
  centerMode: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  focusOnSelect: true,
  pauseOnHover: true,
  speed: 3500,
  responsive: [
    {
      breakpoint: 410,
      settings: {
        variableWidth: false,
      },
    },
  ],
};
interface Props {
  offset: number;
  limit: number;
}
export const DiscoverHomeView: React.FC<Props> = ({ offset, limit }) => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [searchIsClicked] = useState(false);
  const { armFromDiscover } = useCampaignFlow();

  // Fetch categories and offers using hooks
  const { categories, loading } = useFindAllCategories();
  const { myIdentities, loading: identitiesLoading } = useMyIdentities({
    offset,
    limit,
  });
  const hasIdentities = (myIdentities?.length || 0) > 0;

  // Show modal only after identities are loaded AND user has none
  const showModal = !identitiesLoading && !hasIdentities;

  useEffect(() => {
    if (!identitiesLoading && hasIdentities) {
      armFromDiscover();
    }
  }, [armFromDiscover, hasIdentities, identitiesLoading]);


  if (identitiesLoading) {
    return <PageLoader />;
  }

  return (
    <>
      <TemplateSub page={`Discover`}>
        <div className="w-full flex-1 h-full overflow-y-auto pb-4">
          {!searchIsClicked && (
            <div className="px-[1rem]">
              <SearchInput
                prefixIcon={
                  <img src={searchIcon} alt="search" width={20} height={20} />
                }
                id="search"
                name="search"
                type="search"
                placeholder="Search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className=" px-5 w-full flex justify-between items-center gap-5 mt-0"
                onClick={() => navigate(ROUTES.FIND_OFFERS)}
                end2end={false}
              />
            </div>
          )}

          {/* Categories */}
          <div className="grid grid-cols-3 px-[1rem] mt-[1.5rem] gap-4">
            {loading ? (
              <React.Fragment>
                <CategoryCardSkeleton />
                <CategoryCardSkeleton />
                <CategoryCardSkeleton />
              </React.Fragment>
            ) : !categories.length ? (
              <NoticeBox message="No categories at the moment" />
            ) : (
              Array.from(
                [...categories]
                  .sort((a, b) => {
                    // If createdAt is ISO string, parse natively
                    const aTime = moment(a.createdAt).valueOf();
                    const bTime = moment(b.createdAt).valueOf();
                    return aTime - bTime; // earliest to latest
                  })
                  .reduce((map, obj) => {
                    if (!map.has(obj.id)) map.set(obj.id, obj);
                    return map;
                  }, new Map())
                  .values(),
              ).map((c) => (
                <div
                  onClick={() => navigate(`${ROUTES.FIND_CATEGORY}/${c.id}`)}
                  key={c.id}
                  className="bg-[#1E1E1E] rounded-lg p-4 flex flex-col gap-[8px] justify-center h-32 hover:bg-[#2A2844] transition-colors cursor-pointer"
                >
                  <div className="flex flex-col items-center justify-center">
                    <div className="w-[40px] h-[40px] flex items-center justify-center">
                      <img src={c.imgSrc} alt={c.name} />
                    </div>

                    <p className="text-white text-center text-[12px] font-medium mt-2">
                      {c.name}
                    </p>
                  </div>
                </div>
              ))
            )}
          </div>

          <div className="px-[1rem] mt-6">
            <div className="w-full p-3 bg-[#1E1E1E] rounded-lg">
              <div className="flex items-center justify-between">
                <p className="text-[14px] font-[900] text-left text-white">
                  Coming Soon to Njoy 🤩
                </p>
                <Link to={ROUTES.VIEW_ALL_MERCHANTS}>
                  <Button
                    className=" h-7 px-[8px] rounded-[0.375rem]"
                    variant="outline"
                  >
                    <div className="flex gap-[6px] items-center">
                      <p className="text-[12px]"> All Brands</p>
                      <img src={RightIcon} alt="" />
                    </div>
                  </Button>
                </Link>
              </div>
              <hr className="bg-[#77777] mt-3 border w-full border-[#7777]" />
              <div className="flex justify-between items-start mt-3  bg-[#1E1E1E] rounded-lg">
                {products.map((item) => (
                  <div
                    key={item.id}
                    className="flex flex-col justify-start items-center w-[100px] h-[100px] "
                  >
                    <div className="flex justify-center items-center h-[70px]">
                      <img
                        src={item.imgSrc}
                        alt={`brand-${item.id}`}
                        className="object-contain max-h-[70px]"
                      />
                    </div>

                    <p className="text-white text-center text-[10px] leading-tight h-[32px] line-clamp-2 overflow-hidden text-ellipsis">
                      {item.title}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Banner */}
          <div className="px-[1rem]">
            <Link
              to={
                ROUTES.FIND_CATEGORY + "/1c61e349-aea5-40fb-bc5f-c504462cd843"
              }
            >
              <div className="relative w-full mt-6 p-5 bg-[#dcd7f8] rounded-lg">
                <p className="text-[#281289] text-[18px] ">
                  Enjoy Great Food at
                </p>
                <p className="text-[#281289] text-[18px] ">Better Value with</p>
                <img
                  src={blueNjoyLogo}
                  alt="njoy"
                  width={58}
                  height={24}
                  className="mt-1"
                />

                <div
                  className="flex justify-center items-center mt-2 p-1 w-[43%] rounded-[50px]"
                  style={{ border: "1px solid #281289" }}
                >
                  <span className="text-[#281289] text-[12px] cursor-pointer">
                    Discover More
                  </span>
                </div>
                <img
                  src={hotPotIcon}
                  alt="pot"
                  width={800}
                  height={152}
                  className="absolute right-0 bottom-0"
                />
              </div>
            </Link>
          </div>

          {/* Trending Offers */}
          <p className="text-[18px] font-extrabold px-[1rem] mt-6 mb-4 text-left text-white">
            Top Picks For You ✨
          </p>
          <TopMerchant />

          {/* Offers/Ads */}
          <div className="w-full gap-3 overflow-x-auto pb-3">
            {loading ? (
              <Loader text="Loading ads..." />
            ) : !ads.length ? (
              <NoticeBox message="There are no ads at the moment." />
            ) : (
              <Slider
                {...adBannerSliderOptions}
                className="h-[30%]"
                aria-label="Promotional ads slider"
              >
                {ads.map((a) => (
                  <div className="flex-none h-[105px] px-[6px]" key={a.id}>
                    <a href={a.url} target="_blank" rel="noopener noreferrer">
                      <img
                        src={a.imgSrc}
                        className="h-full w-[300px] object-contain rounded-[10px]"
                        alt={`Ad banner ${a.id}`}
                        loading="lazy"
                      />
                    </a>
                  </div>
                ))}
              </Slider>
            )}
          </div>

          {/* Latest offers for you */}
          <p className="text-[18px] px-[1rem] font-extrabold mt-3 text-left text-white">
            Latest Offers For You 🔥
          </p>
          <MyAppSettingController>
            {({ data, loading }) => {
              if (loading) {
                return <PageLoader />;
              }
              const currentLocationId = data?.myAppSetting?.location?.id || "";
              return (
                <SearchOffers
                  variables={{
                    input: {
                      filterByLocationId: currentLocationId,
                      endingSoon: false,
                    },
                    offset: 0,
                    limit: 4,
                  }}
                >
                  {({ offers: searchOffers, loading: searchLoading }) => {
                    return (
                      <div className="w-full flex-1 h-full overflow-y-auto ">
                        <div className="px-[1rem] mt-[12px] overflow-y-scroll mb-[20px]">
                          {searchLoading ? (
                            <div className="flex flex-wrap gap-[24px]">
                              <div className="max-w-[222px]">
                                <OfferCardSkeleton />
                              </div>
                              <div className="max-w-[222px]">
                                <OfferCardSkeleton />
                              </div>
                              <div className="max-w-[222px]">
                                <OfferCardSkeleton />
                              </div>
                            </div>
                          ) : !searchOffers.length ? (
                            <div className="grid gap-4">
                              <NoticeBox message="No offers match this filter at the moment." />
                            </div>
                          ) : (
                            <div className="grid grid-cols-2 gap-4">
                              {(searchOffers || []).map((c) => (
                                <div key={c.id} data-offer-card>
                                  <OfferCountdownCard offer={c} />
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  }}
                </SearchOffers>
              );
            }}
          </MyAppSettingController>

          {/* Expiring Soon */}
          <MyAppSettingController>
            {({ data, loading }) => {
              if (loading) {
                return <PageLoader />;
              }
              const currentLocationId = data?.myAppSetting?.location?.id || "";
              return (
                <FindOffersEndingSoonController
                  variables={{
                    locationId: currentLocationId,
                    offset: 0,
                    limit: 4,
                  }}
                > 
                  {({ offers: searchOffers, loading: searchLoading }) => {
                    return searchOffers.length < 2 ? null : (
                      <>
                        <p className="text-[18px] px-[1rem] font-extrabold mt-3 text-left text-white">
                          Expiring Soon ⏰
                        </p>
                        <div className="w-full flex-1  pb-10">
                          <div className="mt-[12px] mb-[20px]">
                            {searchLoading ? (
                              <div className="flex flex-wrap gap-[24px]">
                                {[1, 2, 3].map((i) => (
                                  <div key={i} className="max-w-[222px]">
                                    <OfferCardSkeleton />
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <Slider {...sliderOptions} className="mb-[12px]">
                                {searchOffers.map((c) => (
                                  <div key={c.id} className="px-2">
                                    <div className="w-[46vw] lg:w-[13vw]">
                                      <OfferCountdownCard offer={c} />
                                    </div>
                                  </div>
                                ))}
                              </Slider>
                            )}
                          </div>
                        </div>
                      </>
                    );
                  }}
                </FindOffersEndingSoonController>
              );
            }}
          </MyAppSettingController>
        </div>
      </TemplateSub>

      <ConnectIdModal visible={showModal} onCancel={() => {}} onOk={() => {}} />
    </>
  );
};
